module.exports = __webpack_public_path__ + "r-v3/img/ico_music_white.593fdfad.svg";